import React from "react";

/**
 * Copilot Light Icon.
 * @returns {JSX.Element} Copilot Light Icon.
 */
const CopilotLightIcon = (): JSX.Element => {
    return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="12" cy="12" r="11.75" fill="#D9D9D9" fillOpacity="0.01" stroke="white" strokeWidth="0.5" />
            <path
                d="M14.4024 3C17.9496 3.00003 21.0975 4.71017 23.0663 7.35094C23.6677 8.78076 24.0003 10.3515 24.0003 12C24.0003 18.6274 18.6277 23.9999 12.0003 24C7.02606 24 2.75887 20.9733 0.939453 16.6612C2.90894 19.2951 6.05245 21 9.59422 21C12.9501 21 15.9484 19.4693 17.9293 17.0681C19.0957 15.7049 19.8003 13.9348 19.8003 12C19.8003 7.69222 16.3081 4.20006 12.0003 4.2C9.55341 4.2 7.36968 5.32681 5.93961 7.08973C7.91802 4.59798 10.9736 3 14.4024 3Z"
                fill="url(#paint0_linear_195_17273)"
            />
            <path
                d="M12 0C16.9786 0 21.2488 3.03199 23.0655 7.35012C21.0966 4.70979 17.9491 3.00003 14.4022 3C10.979 3 7.92795 4.59282 5.94926 7.07754C4.85572 8.4201 4.2 10.1334 4.2 12C4.2 16.3078 7.69218 19.8 12 19.8C14.3731 19.8 16.4985 18.7402 17.9291 17.0681C15.9482 19.4693 12.9499 21 9.59402 21C6.05194 21 2.90812 19.2948 0.938672 16.6605C0.334207 15.2277 0 13.6529 0 12C0 5.37258 5.37258 0 12 0Z"
                fill="url(#paint1_linear_195_17273)"
            />
            <defs>
                <linearGradient
                    id="paint0_linear_195_17273"
                    x1="12.0124"
                    y1="6.12743"
                    x2="17.5947"
                    y2="21.7636"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" stopOpacity="0.01" />
                    <stop offset="0.740385" stopColor="white" />
                </linearGradient>
                <linearGradient
                    id="paint1_linear_195_17273"
                    x1="7.76325"
                    y1="9.64337"
                    x2="10.7846"
                    y2="20.0389"
                    gradientUnits="userSpaceOnUse"
                >
                    <stop stopColor="white" />
                    <stop offset="1" stopColor="white" stopOpacity="0.01" />
                </linearGradient>
            </defs>
        </svg>
    );
};

export { CopilotLightIcon };
